import { CommentsActions, CommentsActionsType } from "./comments.actions";
import { createCommentsState } from "../types/comments-state/comments-state.functions";

export const commentsReducer = (state = createCommentsState(), action: CommentsActionsType) => {
  switch (action.type) {
    case CommentsActions.ResetState:
      return createCommentsState();

    case CommentsActions.Fetch:
    case CommentsActions.Post:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case CommentsActions.FetchFailure:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        searchResults: null,
      };

    case CommentsActions.PostFailure:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    case CommentsActions.FetchSuccess:
      return {
        ...state,
        loading: false,
        errors: null,
        searchResults: action.payload,
      };

    case CommentsActions.PostSuccess:
      return {
        ...state,
        loading: false,
        errors: null,
      };

    default:
      return state;
  }
};
